<template>
  <li>
    <a
      tabindex="-1"
      unselectable="on"
      class="toolbar-item toolbar-item-image"
      title="Inserire immagine"
      @click="cliccato()"
      v-bind:class="{ open: menuOpen }"
    >
      <span class="simditor-icon">
        <i class="fa-light fa-clipboard-list"></i>
      </span>
    </a>
    <div class="ul" v-if="menuOpen">
      <span v-if="response.length == 0" style="font-size: 14px; font-weight: 100">{{ i18nJS.loading }}...</span>
      <div @click="openDecodes()" class="li" style="font-size: 14px; font-weight: 100">{{ i18nJS.go_to_decodes }}</div>
      <div v-for="(res, index) in response" v-bind:key="index" @click="addText(res.desc)" class="li">
        <i class="fa-light fa-circle small"></i>
        {{ res.cod }}
      </div>
    </div>
  </li>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';

export default {
  name: 'customTextDecoded',
  props: [],
  components: {},
  data() {
    return {
      menuOpen: false,
      url: `/${window.locale}/decodes_configs`,
      response: [],
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  mounted() {
    this.requestDecodes();
  },
  methods: {
    requestDecodes() {
      apiConnector()
        .get(`${this.url}/get_values.json?business_unit_id=${window.config.business_unit.id}&cod=custom_text_decoded&key=generale`)
        .then((res) => {
          this.response = res.data;
        });
    },
    addText(text) {
      this.menuOpen = false;
      this.$emit('addTextEvent', text);
    },
    cliccato() {
      this.menuOpen = !this.menuOpen;
    },
    getTemplate() {
      return this.template;
    },
    openDecodes() {
      this.$emit('openDecodesEvent');
    },
  },
};
</script>

<style lang="scss" scoped>
.li {
  cursor: pointer;
  height: 22px;
  display: flex;
  align-items: center;
  &:hover {
    background: #eeeeee;
  }
}
.ul {
  height: 120px;
  overflow-y: auto;
  position: absolute;
  border: 1px solid #eeeeee;
  width: 170px;
  height: 150px;
  font-size: 14px;
  background: white;
  z-index: 9999;
}
.small {
  margin: 0 5px;
  font-size: 8px;
}
.open {
  background: #eeeeee;
}
</style>
